
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Twitter'
})
export default class Twitter extends Vue {}
